import * as React from 'react';
import { BasePureComponent } from './BaseComponent';
import * as Dati from '../Dati';
import { Trad, Tipo } from '../components/';


interface ICampoProvinciaProps extends Dati.IBaseProps {
    Valore: string;
    Disabilitato?: boolean
    Comune?: string
    CAP?: string
}

export class CampoProvincia extends BasePureComponent<ICampoProvinciaProps, {}> {
    private _Comuni: Dati.CComune[];
    private _ListaProvincia: Dati.TDictTipo = {};

    constructor(props: any) {
        super(props);
        this._Comuni = require('./Dati/comuni.json');
    }

    private PopolaProvincia() {
        this._ListaProvincia = {};
        let comuniApp: Dati.CComune[] = this._Comuni;
        if (this.props.CAP != undefined && this.props.CAP != "") {
            let cap: string = this.props.CAP;
            comuniApp = comuniApp.filter(c => c.cap.indexOf(cap) >= 0);
        }
        if (this.props.Comune != undefined && this.props.Comune != "") {
            let comune: string = this.props.Comune;
            comuniApp = comuniApp.filter(c => c.nome == comune);
        }
        for (let i: number = 0; i < comuniApp.length; i++) {
            this._ListaProvincia[comuniApp[i].sigla] = new Dati.CTipo(comuniApp[i].sigla, comuniApp[i].sigla);
        }
    }

    public render() {
        this.PopolaProvincia();
        return <Tipo Dati={this._ListaProvincia} ID_ChiaveString={this.props.Valore} Campo={this.props.Name} OnAggiorna={this.props.OnChange} OnBlur={this.props.OnBlur} Disabilitato={this.props.Disabilitato} TradValori={false} />;
    }
}


// WEBPACK FOOTER //
// ./src/components/CampoProvincia.tsx